import { MaterialCheckboxController } from "./material-checkbox.controller";
import { Bindings } from "booking_app/types";

export class MaterialCheckbox {
  controller: any = MaterialCheckboxController;
  bindings: any = {
    ngModel: Bindings.ONE_WAY,
  };

  require: any = {
    ngModelController: "ngModel",
  };

  transclude: any = {
    checkboxContent: "?checkboxContent",
  };

  template: string = `
    <div ng-transclude="checkboxContent"
    ng-click="$ctrl.internetExplorerChecker()">
    </div>
  `;
}

angular.module("BookingApp").component("materialCheckbox", new MaterialCheckbox());
